import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen bg-black flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5142cf0277cdaabfdd127131ecf8bc33.jpg"
          alt="Ark Capital Hero"
          className="w-full h-full object-cover object-top opacity-90"
        />
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-black/15"></div>

      {/* Floating data points - desktop only */}
      <div className="absolute top-1/3 left-16 text-white opacity-50 hidden lg:block">
        <div className="text-3xl font-bold text-yellow-600">$2.4B</div>
        <div className="text-xs tracking-widest text-white/60 mt-1">ASSETS UNDER MANAGEMENT</div>
      </div>
      <div className="absolute bottom-1/3 left-16 text-white opacity-50 hidden lg:block">
        <div className="text-3xl font-bold text-yellow-600">47</div>
        <div className="text-xs tracking-widest text-white/60 mt-1">ACTIVE PROJECTS</div>
      </div>
      <div className="absolute top-1/3 right-16 text-white opacity-50 hidden lg:block">
        <div className="text-3xl font-bold text-yellow-600">12</div>
        <div className="text-xs tracking-widest text-white/60 mt-1">COUNTRIES</div>
      </div>
      <div className="absolute bottom-1/3 right-16 text-white opacity-50 hidden lg:block">
        <div className="text-3xl font-bold text-yellow-600">$850M+</div>
        <div className="text-xs tracking-widest text-white/60 mt-1">DEPLOYED CAPITAL</div>
      </div>

      {/* Center Content */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-8 w-full mt-16 sm:mt-0 lg:-mt-24">
        {/* Logo */}
        <div className="mb-4 sm:mb-6">
          <img
            src="https://static.readdy.ai/image/dadfa7b8e8bbab8ae3e8df395caac6f8/4d04083fcc989b7aa0d3613feaac88ac.png"
            alt="Ark Capital"
            className="h-40 sm:h-64 lg:h-96 w-auto mx-auto drop-shadow-2xl mix-blend-screen brightness-110"
          />
        </div>

        {/* Headline */}
        <h1 className="text-white mb-6 sm:mb-8 max-w-5xl w-full">
          <div className="text-3xl sm:text-5xl lg:text-7xl font-bold leading-tight tracking-tight">
            STRATEGIC CAPITAL FOR
          </div>
          <div className="text-3xl sm:text-5xl lg:text-7xl font-bold leading-tight tracking-tight text-yellow-600">
            INFRASTRUCTURE, INDUSTRY,
          </div>
          <div className="text-3xl sm:text-5xl lg:text-7xl font-bold leading-tight tracking-tight">
            AND GLOBAL TRADE
          </div>
        </h1>

        {/* Subheadline */}
        <p className="text-white/60 text-sm sm:text-base lg:text-lg font-light leading-relaxed max-w-2xl mb-8 sm:mb-12 px-2">
          Ark Capital™ is a private investment and development firm focused on infrastructure, industrial development, logistics, and global trade projects. We partner with investors, operators, and developers to finance and build high-value assets that drive economic growth.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 w-full sm:w-auto px-4 sm:px-0">
          <a
            href="#portfolio"
            className="bg-yellow-600 text-black px-8 sm:px-12 py-4 font-semibold tracking-widest text-sm hover:bg-yellow-500 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
          >
            VIEW INVESTMENTS
          </a>
          <a
            href="#partnership"
            className="border border-yellow-600 text-yellow-600 px-8 sm:px-12 py-4 font-semibold tracking-widest text-sm hover:bg-yellow-600/10 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
          >
            PARTNER WITH US
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50">
        <div className="w-px h-12 bg-yellow-600"></div>
        <i className="ri-arrow-down-line text-yellow-600 text-lg"></i>
      </div>
    </section>
  );
}
